<template lang="html" v-if="client">
  <div class="wrapper" :style="{ 'background-image': 'url(' + client.background + ')', 'background-color': '#EEEEEE' }" >
    <div class="bg text-center">
      <img :src="client.logo" alt="Logo de la compañia" class="logo">
      <div class="container-fluid">
        <div class="row justify-content-center">
            <h2>Se ha dado de baja satisfactoriamente, ¡Gracias!</h2>
        </div>
      </div>
      <a :href="defaultWeb" target="_blank" class="logo-footer-content-right">
        <img :src="defaultLogo" alt="Logo">
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/survey.css';

Vue.use(BootstrapVue);

export default {
  data: () => {
    return {
      completed: false,
      data: null,
      client: null,
      defaultLogo: process.env.LOGO_PATH,
      defaultWeb: process.env.URL_WEB
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.loader = true;
      const contact_id = this.$route.params.contact_id;
      let url = 'unsubscribe/' + contact_id;
      window.axios.get(url).then(response => {
        const data = response.data;
        this.client = data.client;
        console.log(data.client);
        this.loader = false;
      }).catch(error => {
        this.loader = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/surveys/Thanks.vue